@if (activity && activity.activity_text) {
  @if (activity.activity_text.length > 1) {
    <div>
      @for (activityText of activity.activity_text; track activityText) {
        <div
          (click)="onTabChange.emit(activityText)"
          class="tab"
          [class.selected]="activityText.default_lang_id === selectedLanguage"
          >
          {{ languageService.convertCodeToName(activityText.default_lang_id) }}
        </div>
      }
    </div>
  }
}
